import { createContainer, createHook, createStore } from '@atlassian/react-sweet-state';
import { actions, type Actions } from './actions';
import {
	getExternalLinks,
	getIsDeleting,
	getIsAdding,
	getIsUpdating,
	getIsReordering,
	getLinkIcon,
} from './selectors';
import type { State, Props } from './types';

const initialState: State = {
	isDeleting: false,
	isAdding: false,
	isUpdating: false,
	isReordering: false,
	links: {
		isLoading: true,
		data: [],
		error: null,
		totalSize: 0,
	},
	icons: {},
};

export const store = createStore<State, Actions>({
	initialState,
	actions,
	name: 'ExternalLinksStore',
});

export const ExternalLinksContainer = createContainer<State, Actions, Props>(store, {
	displayName: 'ExternalLinksContainer',
});

export const useExternalLinks = createHook(store, {
	selector: getExternalLinks,
});

export const useIsDeleting = createHook(store, {
	selector: getIsDeleting,
});

export const useIsAdding = createHook(store, {
	selector: getIsAdding,
});

export const useIsUpdating = createHook(store, {
	selector: getIsUpdating,
});

export const useIsReordering = createHook(store, {
	selector: getIsReordering,
});

export const useLinkIcon = createHook(store, {
	selector: getLinkIcon,
});
